var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.4502 2.80005C2.4502 1.28126 3.68141 0.0500488 5.2002 0.0500488H15.1095C15.9156 0.0500488 16.6811 0.403731 17.2036 1.01757L20.8943 5.35351C21.3177 5.85091 21.5502 6.48279 21.5502 7.13599V21.2C21.5502 22.7188 20.319 23.95 18.8002 23.95H5.2002C3.68141 23.95 2.4502 22.7188 2.4502 21.2V2.80005ZM5.2002 1.55005C4.50984 1.55005 3.9502 2.10969 3.9502 2.80005V21.2C3.9502 21.8904 4.50984 22.45 5.2002 22.45H18.8002C19.4906 22.45 20.0502 21.8904 20.0502 21.2V7.13599C20.0502 6.83908 19.9445 6.55186 19.7521 6.32577L16.0614 1.98983C15.8239 1.71081 15.4759 1.55005 15.1095 1.55005H5.2002Z",
    fill: "#002136"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8H14",
    stroke: "#002136",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13H17",
    stroke: "#002136",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 18H17",
    stroke: "#002136",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.c5dfb65b1524fe8c13353a131c39da06.svg";
export { ForwardRef as ReactComponent };